if (!customElements.get('datu-gear-filters')) {
  customElements.define('datu-gear-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.preview !== 'true' || this.initialized) return;
      this.initialized = true;
      this.onClick = event => {
        const option = event.target.closest('[data-gear-filter]');
        if (!option || !this.contains(option) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.apply(option.dataset.gearFilter, true);
      };
      this.onPopState = () => this.apply(new URL(location.href).searchParams.get('gear') || 'all', false);
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopState);
      if (document.readyState === 'loading') {
        this.onReady = () => this.onPopState();
        document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      } else {
        queueMicrotask(this.onPopState);
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onPopState);
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.initialized = false;
    }
    apply(group, updateUrl) {
      if (!this.isConnected) return;
      const options = Array.from(this.querySelectorAll('[data-gear-filter]'));
      if (!options.some(option => option.dataset.gearFilter === group)) group = 'all';
      const collection = this.closest('.datu-gear-collection');
      if (!collection) return;
      const cards = Array.from(collection.querySelectorAll('product-list > [data-datu-gear-groups]'));
      let count = 0;
      for (const card of cards) {
        const groups = card.dataset.datuGearGroups.split(' ');
        const visible = group === 'all' || groups.includes(group);
        card.hidden = !visible;
        if (visible) count++;
      }
      for (const option of options) {
        if (option.dataset.gearFilter === group) option.setAttribute('aria-current', 'true');
        else option.removeAttribute('aria-current');
      }
      this.querySelector('[data-gear-result-count]').textContent = this.dataset.countLabel.replace('__COUNT__', String(count));
      if (updateUrl) {
        const url = new URL(location.href);
        if (group === 'all') url.searchParams.delete('gear');
        else url.searchParams.set('gear', group);
        url.hash = 'datu-gear-products';
        history.pushState({}, '', url);
      }
    }
  });
}
